import { useState } from "react";
import { X } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const resetLine = (msg) => {
  const m = (msg || "").toLowerCase();
  if (m.includes("today")) return "Resets at midnight tonight, your local time.";
  if (m.includes("month")) return "Resets on the 1st of next month.";
  return null;
};

export const LimitDialog = ({ message, showUpgrade, resume, onClose }) => {
  const [going, setGoing] = useState(false);
  if (!message) return null;
  const upgrade = async () => {
    setGoing(true);
    try {
      const { data } = await api.post("/payments/checkout", { lookup_key: "pro_monthly", origin_url: window.location.origin, return_path: window.location.pathname });
      if (resume) sessionStorage.setItem("ihmj_resume", resume);
      window.location.href = data.checkout_url;
    } catch { toast.error("Couldn't start checkout. Try again."); setGoing(false); }
  };
  const reset = resetLine(message);
  return (
    <div className="fixed inset-0 z-[130] flex items-center justify-center bg-black/70 px-5" data-testid="limit-dialog">
      <div className="relative w-full max-w-md card-panel bg-[#14161B] border border-[#2A2E39] rounded-lg p-6 text-center">
        <button onClick={onClose} className="absolute top-3 right-3 text-gray-400 hover:text-white" aria-label="Close" data-testid="limit-dialog-close">
          <X size={18} />
        </button>
        <div className="eyebrow text-[#FD0F10]">AI COACH</div>
        <p className="text-white font-bold mt-3" data-testid="limit-dialog-message">{message}</p>
        {reset && <p className="text-gray-400 text-sm mt-2" data-testid="limit-dialog-reset">{reset}</p>}
        <div className="mt-5 flex flex-col sm:flex-row gap-2 justify-center">
          {showUpgrade && (
            <button onClick={upgrade} disabled={going} className="hero-accent text-white font-bold px-6 py-2.5 rounded disabled:opacity-60" data-testid="limit-dialog-upgrade">{going ? "Opening checkout…" : "Upgrade to Pro"}</button>
          )}
          <button onClick={onClose} className="border border-[#2A2E39] text-white font-bold px-6 py-2.5 rounded" data-testid="limit-dialog-ok">Got it</button>
        </div>
      </div>
    </div>
  );
};
